export default "__VITE_ASSET__c93b0ecf__"